import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './privatePage.css';

const MAX_TODO_LENGTH = 255;

const PrivateComponent = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [tasks, setTasks] = useState([]);
  const [doneTasks, setDoneTasks] = useState([]); // Tâches effectuées (depuis CSV)
  const [todoInput, setTodoInput] = useState('');
  const [parentId, setParentId] = useState('');
  const topRef = useRef(null);

  useEffect(() => {
    fetchTasks();
  }, []);



  const fetchTasks = async () => {
    try {
      const response = await fetch('/privateZone/get_tasks.php', {
        method: 'GET',
        credentials: 'include',
      });
      if (response.status === 401) {
        navigate('/login');
        return;
      }
      const data = await response.json();
      const sortedTasks = sortTasks(data);
      setTasks(sortedTasks);
    } catch (error) {
      console.error('Error fetching tasks:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const sortTasks = (tasks) => {
    // Create a map for quick lookup of tasks by their id
    const taskMap = {};
    tasks.forEach(task => {
      taskMap[task.id] = { ...task, children: [] };
    });

    // Populate children for each task
    const sortedTasks = [];
    tasks.forEach(task => {
      if (task.parent_id === null) {
        sortedTasks.push(taskMap[task.id]);
      } else {
        taskMap[task.parent_id].children.push(taskMap[task.id]);
      }
    });

    // Flatten the sorted tasks with children
    const flattenTasks = (taskList) => {
      return taskList.reduce((acc, task) => {
        return acc.concat([task, ...flattenTasks(task.children)]);
      }, []);
    };

    return flattenTasks(sortedTasks);
  };
  
  const addTask = async () => {
    if (!todoInput.trim() || todoInput.length > MAX_TODO_LENGTH) return;
    try {
      const response = await fetch('/privateZone/get_tasks.php', {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({ text: todoInput, parent_id: parentId || null }),
      });
      if (response.status === 401) { navigate('/login'); return; }
      if (response.ok) {
        setTodoInput('');
        setParentId('');
        fetchTasks();
      }
    } catch (error) {
      console.error('Error adding task:', error);
    }
  };


  const formatTaskText = (text) => {
    const hasKeyword = text.includes('!');
    const displayText = text.replace('!', '').trim();
    const hasKeyTitle = text.includes('TODO ');
    return { displayText, isImportant: hasKeyword, isTitle: hasKeyTitle};
  };




  const toggleTaskCompletion = async (id) => {
    try {
      const response = await fetch('/privateZone/delete_tasks.php', {
        method: 'DELETE',
        credentials: 'include',
        body: JSON.stringify({ id }),
      });
      if (response.status === 401) { navigate('/login'); return; }
      if (response.ok) {
        fetchTasks();
      }
    } catch (error) {
      console.error('Error toggling task completion:', error);
    }
  };



  const fetchDoneTasksFromCSV = async () => {
    try {
      const response = await fetch('/privateZone/get_done_tasks.php', {
        method: 'GET',
        credentials: 'include',
      });
      const data = await response.json();
      setDoneTasks(data.todos);
      
    } catch (error) {
      console.error('Error fetching done tasks from CSV:', error);
    }
  };


  const handleLogout = async () => {
    await fetch('/privateZone/logout.php', {
      method: 'POST',
      credentials: 'include',
    });
    navigate('/');
  };


  if (isLoading) {
    return <div className="spinner"></div>;
  }

  const clearDoneTasks = () => {
    setDoneTasks([]);
  };

  return (
    <div className="todo-container">
      <div className="animated-section">

        <div className="input-container">
          <input
            type="text"
            value={todoInput}
            onChange={(e) => setTodoInput(e.target.value)}
            placeholder="Ajouter une nouvelle tâche..."
            maxLength={MAX_TODO_LENGTH}
          />
          {todoInput.length > 0 && (
            <span className={`char-counter ${todoInput.length >= MAX_TODO_LENGTH * 0.9 ? 'char-counter--warn' : ''}`}>
              {todoInput.length}/{MAX_TODO_LENGTH}
            </span>
          )}
          <div className="select-and-add">
            <select value={parentId} onChange={(e) => setParentId(e.target.value)}>
              <option value="">Aucun Parent</option>
              {tasks.filter(task => !task.parent_id).map(task => (
                <option key={task.id} value={task.id}>
                  {task.text.length > 20 ? `${task.text.substring(0, 20)}...` : task.text}
                </option>
              ))}
            </select>
            <button className="add-button" onClick={addTask} disabled={todoInput.length >= MAX_TODO_LENGTH}>Ajouter</button>
          </div>
        </div>
        <ul id="todo-list">
          {tasks.map(task => {
            const { displayText, isImportant, isTitle } = formatTaskText(task.text);
            return (
              <li key={task.id} style={{ marginLeft: task.parent_id ? '20px' : '0px' }}>
                <input type="checkbox" onChange={() => toggleTaskCompletion(task.id)} />
                <span
                  style={{
                    textDecoration: task.completed ? 'line-through' : 'none',
                    color: isImportant ? '#FF0014' : isTitle ? '#EEFF00' : 'inherit',
                    fontWeight: isImportant ? 'bold' : isTitle ? 'bold' : 'inherit',
                    textShadow: isImportant ? '0 0 1px #ff0000' : 'none',
                  }}
                >
                  {displayText}
                </span>
              </li>
            );
          })}
        </ul>

      </div>
      <div className="bottom-buttons">
        <button
          onClick={doneTasks.length > 0 ? clearDoneTasks : fetchDoneTasksFromCSV}
          className="fetch-csv-button"
        >
          {doneTasks.length > 0 ? 'Masquer les tâches effectuées' : 'Charger les tâches effectuées'}
        </button>
        <button className="fetch-csv-button" onClick={() => navigate('/drive')}>
          Drive
        </button>
      </div>
      {doneTasks.length > 0 && (
        <div className="task-block">
          <ul id="done-list">
            {[...doneTasks]
              .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
              .map(doneTask => {
                const createdAt = new Date(doneTask.created_at);
                const doneAt = new Date(doneTask.done_at);
                const createdDayMonthYear = `${String(createdAt.getDate()).padStart(2, '0')}/${String(createdAt.getMonth() + 1).padStart(2, '0')}/${String(createdAt.getFullYear()).substr(-2)}`;
                const doneDayMonthYear = `${String(doneAt.getDate()).padStart(2, '0')}/${String(doneAt.getMonth() + 1).padStart(2, '0')}/${String(doneAt.getFullYear()).substr(-2)}`;
                return (
                  <li key={doneTask.id} style={{ fontSize: '0.8em' }}>
                    <span>
                      {doneTask.text} ({createdDayMonthYear} - {doneDayMonthYear})
                    </span>
                  </li>
                );
              })}
          </ul>
        </div>




      )}

      <button onClick={handleLogout} className="logout-button">
        Logout
      </button>
    </div>
  );
};

export default PrivateComponent;
